/// <reference path="Utilities/_reference.ts" />

module YVR.DialogflowChatbot {
	'use strict';

	// Utilities
	import date = YVR.Utilities.Dates;

	// Classes
	const classes = {
		chatbot: 'yvr-chat-interface__container',
		chatbotactive: 'yvr-chat-interface__container--active',
		buttoncontainer: 'yvr-chat-button__container',
		buttoncontaineractive: 'yvr-chat-button__container--active',
		button: 'yvr-chat-button__label'

	};


	function main() {
		eventBindings();
	}


	/**
	 * Set the event bindings on the lounge elements.
	 */
	function eventBindings() {
		$(`.${classes.button}`).on('click', e => {
			e.preventDefault();
			console.log($(`.${classes.chatbot}`));
			if ($(`.${classes.chatbot}`).hasClass(`${classes.chatbotactive}`)) {
				$(`.${classes.chatbot}`).removeClass(`${classes.chatbotactive}`);
				$(`.${classes.buttoncontainer}`).removeClass(`${classes.buttoncontaineractive}`);
			} else {
				$(`.${classes.chatbot}`).addClass(`${classes.chatbotactive}`);
				$(`.${classes.buttoncontainer}`).addClass(`${classes.buttoncontaineractive}`);
			}
			
		});
		
	}



	main();
}
